export default __webpack_public_path__ + "static/features-phone-truaccent-f5de0677ac0874e22a142c14ad8bffea.png";